import React from 'react';
import { compose } from 'redux';
import CloakLoading from '../../../../components/CloakLoading';
import Translations from '../../../../containers/Translations';
import { codes } from '../../../../data/translations';
import { Toggleable } from '../../../../utils/decorators';
import { forgotPassword } from '../../api';
import { AuthenticationContext, actionTypeEnum } from '../../consts';
import AuthenticationBackButton from '../AuthenticationBackButton';
import AuthenticationDescription from '../AuthenticationDescription';
import AuthenticationMessage from '../AuthenticationMessage';
import AuthenticationTitle from '../AuthenticationTitle';
import { AuthenticationForgotPasswordForm } from './AuthenticationForgotPasswordForm';

const AuthenticationForgotPasswordComponent = (props) => {
	const { isSubmitted, enableProp, disableProp, authenticationSetActionType, translate, isPending } = props;

	const handleForgotPasswordFormSubmit = (values) => {
		enableProp('isPending')();
		return forgotPassword(values)
			.then(handleForgotPasswordFormSubmitSuccess)
			.catch(handleForgotPasswordFormSubmitError);
	};

	const handleForgotPasswordFormSubmitSuccess = () => {
		enableProp('isSubmitted')();
		disableProp('isPending')();
	};

	const handleForgotPasswordFormSubmitError = ({
		response: {
			data: { errors },
		},
	}) => {
		disableProp('isPending')();
		if (errors._.wrongLogInUseADFS) {
			authenticationSetActionType(actionTypeEnum.WRONG_LOGIN_USE_ADFS);
		}
		if (errors._.wrongLogInUseAzureAd) {
			authenticationSetActionType(actionTypeEnum.WRONG_LOGIN_USE_AZURE_AD);
		}
	};

	const handleBackClick = () => {
		authenticationSetActionType(actionTypeEnum.LOGIN_FORM);
	};

	return (
		<>
			{isPending && <CloakLoading />}
			{!isSubmitted ? (
				<>
					<AuthenticationTitle>
						<AuthenticationBackButton onClick={handleBackClick} />
						{translate(codes.user.forgotPassword)}
					</AuthenticationTitle>
					<AuthenticationDescription>
						{translate(codes.user.forgotPasswordSendEmailTip)}
					</AuthenticationDescription>
					<AuthenticationContext.Consumer>
						{({ forgotPasswordEmail }) => (
							<AuthenticationForgotPasswordForm
								onSubmit={handleForgotPasswordFormSubmit}
								initialValues={{
									email: forgotPasswordEmail,
								}}
								translate={translate}
							/>
						)}
					</AuthenticationContext.Consumer>
				</>
			) : (
				<AuthenticationMessage
					onButtonClick={handleBackClick}
					message={translate(codes.user.pleaseCheckYourEmail)}
					buttonText={translate(codes.user.backToLoginPage)}
				/>
			)}
		</>
	);
};

export const AuthenticationForgotPassword = compose(
	Translations,
	Toggleable({
		isSubmitted: false,
		isPending: false,
	}),
)(AuthenticationForgotPasswordComponent);
